import { Button, Message, Modal, Popover } from "@arco-design/web-react";
import {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fileUploadStore, UploadType } from "@/stores/UploadStroe";
import useProject from "@/useStore/createspace/useProject";
import { v4 as uuid } from "uuid";
import LocalUploadCard from "@/components/business/MaterialFileModal/LocalUpload/LocalUploadCard/LocalUploadCard";
import { CardTypeEnum } from "@/pages/CreationSpace/components/MaterialCard/MaterialCard";
import { observer } from "mobx-react";
import tipImg from "@/assets/create-space/tip.png";
import "./UploadMaterialFile.less";
import UploadButtonBg from "@/components/business/MaterialFileModal/UploadButtonBg/UploadButtonBg";
// import Ton from "@/components/Hocicon";
interface UploadMaterialFileProps {
  ref?: any;
  handleFileChange: (data: any) => void;
  handleOKBtnClick: () => void;
  folderId: number;
  allowType: string;
  uploadType?: UploadType;
}

const UploadMaterialFile: React.FC<UploadMaterialFileProps> = observer(
  forwardRef((props, ref) => {
    const { projectId } = useProject();
    const {
      allowType,
      handleOKBtnClick,
      folderId,
      uploadType = "media",
    } = props;
    const [visible, setVisible] = useState(false);
    const [ids, setIds] = useState<string[]>([]);
    const fileUploadRef = useRef<HTMLInputElement>(null);
    const handleFilesChange = () => {
      setVisible(true);
      const groupName = `分组${fileUploadStore.uploadTasks.length > 0 ? fileUploadStore.uploadTasks.length : 0}`;
      const files = fileUploadRef.current?.files;
      if (files.length > 100) {
        Message.error("最大限制100个文件数！");
        return;
      }
      const oversizedFiles = Array.from(files).filter(
        (file) => file.size > 1024 * 1024 * 1024 * 5
      );
      if (oversizedFiles.length > 0) {
        Message.error("文件大小不能超过5GB！");
        return;
      }
      const batchId = uuid();
      setIds([...ids, batchId]);
      if (files) {
        const fileArray = Array.from(files);
        fileUploadStore.addUploadTasks(
          fileArray,
          folderId,
          projectId,
          groupName,
          batchId,
          uuid(),
          uploadType
        );
        fileUploadRef.current.value = "";
      }
    };

    const isShowPopover = () => {
      const validateFileUploadTasks = (fileUploadStore?.uploadTasks || [])
        .filter((uploadTasks) => ids.includes(uploadTasks.id))
        .map((item) => item.taskList)
        .flat();
      return validateFileUploadTasks.some(
        (item) =>
          item.status === "uploading" ||
          item.status === "queued" ||
          item.status === "parseLoading"
      );
    };

    useEffect(() => {
      if (!visible) {
        setIds([]);
      }
    }, [visible]);

    useImperativeHandle(ref, () => ({
      upload: () => {
        fileUploadRef.current.click();
        return false;
      },
    }));

    return (
      <>
        <div className="upload-button">
          <Button
            style={{ background: "white", color: "rgba(52, 145, 250,1)" }}
            className="btn"
            onClick={() => {
              if (fileUploadRef.current) {
                fileUploadRef.current.click();
              }
            }}
          >
            上传素材
          </Button>
        </div>
        <input
          type="file"
          style={{ display: "none" }}
          accept={allowType}
          multiple={true}
          ref={fileUploadRef}
          onChange={(e) => {
            console.log(e);
            handleFilesChange();
          }}
        />
        <Modal
          onCancel={() => {
            setVisible(false);
          }}
          className={"upload-material-modal"}
          visible={visible}
          title={"上传素材"}
          style={{ width: 806, height: 681 }}
          footer={
            <>
              {!isShowPopover() ? (
                <Button
                  type="primary"
                  onClick={() => {
                    setVisible(false);
                    handleOKBtnClick();
                  }}
                >
                  确定
                </Button>
              ) : (
                <>
                  <Popover
                    content={
                      <div
                        style={{
                          padding: "9px 15px",
                          fontWeight: "400",
                          fontSize: 14,
                          color: "#333333",
                          display: "flex",
                          alignItems: "center",
                          background: "#FFFFFF",
                          boxShadow: "0px 4px 10px 0px rgba(221,221,221,0.45)",
                          marginRight: "20px",
                          border: "1px solid #DDDDDD",
                          borderRadius: 6,
                        }}
                      >
                        <img
                          src={tipImg}
                          alt=""
                          style={{
                            width: "14px",
                            height: "14px",
                            marginRight: "7px",
                          }}
                        />
                        点击确定后，未上传完成的文件会在任务中心继续上传
                      </div>
                    }
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        setVisible(false);
                        handleOKBtnClick();
                      }}
                    >
                      确定
                    </Button>
                  </Popover>
                </>
              )}
            </>
          }
        >
          <div className="metarial-upload-list">
            <UploadButtonBg
              style={{
                height: 112,
                width: 106,
                marginRight: 16,
                marginBottom: 7,
              }}
              onClick={() => {
                if (fileUploadRef.current) {
                  fileUploadRef.current.click();
                }
              }}
            />
            {(fileUploadStore?.uploadTasks || [])
              .filter((uploadTasks) => ids.includes(uploadTasks.id))
              .map((batch) =>
                batch.taskList.map((task) => (
                  <Fragment key={task.id}>
                    <LocalUploadCard
                      onChange={(e) => {
                        console.log(e);
                      }}
                      error={task.error}
                      disOpearte={true}
                      checked={false}
                      item={task.detailMaterial}
                      cover={task.img}
                      type={task.type as CardTypeEnum}
                      name={task.file.name}
                      state={task.status}
                      handleCloseBtnClick={() => {
                        fileUploadStore.cancelUploadTask(task.id);
                      }}
                      handleCencelBtnClick={() => {
                        fileUploadStore.cancelUploadTask(task.id);
                      }}
                      progress={task.progress}
                    />
                  </Fragment>
                ))
              )}
          </div>
        </Modal>
      </>
    );
  })
);

export default UploadMaterialFile;
